import { render, staticRenderFns } from "./DesmatamentoParaguaiVega.vue?vue&type=template&id=c2e8448a&scoped=true&lang=pug"
import script from "./DesmatamentoParaguaiVega.vue?vue&type=script&lang=js"
export * from "./DesmatamentoParaguaiVega.vue?vue&type=script&lang=js"
import style0 from "./DesmatamentoParaguaiVega.vue?vue&type=style&index=0&id=c2e8448a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e8448a",
  null
  
)

export default component.exports